<div class="p-my-5" *ngIf="!isLoading">
    <p-table
    #dt
    [value]="challengesRefTableValue"
    dataKey="id"
    styleClass="p-datatable-itemsref"
    [rows]="10"
    [(selection)]="selectedChallenges"
    selectionMode=""
    [metaKeySelection]="false"
    (onRowSelect)="onRowCheckboxToggle($event.data, true)"
    (onRowUnselect)="onRowCheckboxToggle($event.data, false)"
    [loading]="isLoading"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
    [filterDelay]="0"
    [globalFilterFields]="['id','name']"
    >
        <ng-template pTemplate="caption">
          <ng-container  *ngIf="!isLoading">
            <div class="p-d-flex p-grid">
              <div class="p-col-12">
                <span class="p-fluid p-input-icon-left" [ngStyle]="{ align: 'left', width: '50%' }">
                  <i class="pi pi-search"></i>
                  <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')" placeholder="Search Table" [style]="{ width: '50%' }">
                </span>
              </div>
              <div class="p-col-12 p-d-flex">
                <!-- AutoComplete -->
                <div class="p-col-7">
                  <p-autoComplete
                    class="copyExistingItemDialogAutoComplete"
                    [ngModelOptions]="{ standalone: true }"
                    [suggestions]="suggestions['challenges_ref']"
                    (completeMethod)="utilitiesService.getSuggestionsForRef(suggestions, $event.query, 'challenges_ref', 'challenges')"
                    [showEmptyMessage]="true"
                    field="id"
                    minLength="3"
                    (onSelect)="onSelection($event)"
                    [(ngModel)]="selectedChallenge"
                    placeholder="Add Challenge"
                  >
                    <ng-template let-challenge pTemplate="challenge">
                      ({{ challenge.id }}) {{ challenge.name }}
                    </ng-template>
                  </p-autoComplete>
                </div>
                <!-- Switch and Button -->
                <div class="p-col-4 p-ml-auto" [ngStyle]="{ 'display': 'flex', 'justify-content': 'flex-end'}">
                  <span class="p-ml-4">
                    <p-inputSwitch [(ngModel)]="isBulkDelete" (onChange)="toggleBulkDelete($event)"></p-inputSwitch>
                    <small class="p-mb-1">Bulk Delete</small>
                  </span>
                  <p-button
                    label="Delete Selected Challenges" icon="pi pi-trash" class="p-ml-2" styleClass="p-button-danger p-button-sm"
                    [disabled]="selectedChallenges.length <= 0" (click)="confirmRemoveSelectedChallenges()"
                  ></p-button>
                </div>
              </div>
            </div>
          </ng-container>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th></th>
                <th>ID</th>
                <th>Name</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-challenge let-rowIndex="rowIndex">
            <tr [pSelectableRow]="challenge" [pSelectableRowIndex]="rowIndex" class="p-text-uppercase">
                <td>
                  <div *ngIf="!isBulkDelete" pButton pRipple type="button"
                      class="p-button-rounded p-button-text"
                      icon="pi pi-trash"
                      iconPos="left"
                      (click)="confirmRemoveChallengeRef(challenge)">
                  </div>
                  <p-tableCheckbox
                    [value]="challenge"
                    #checkboxTableP
                    [index]="rowIndex"
                    (click)="checkboxTable(checkboxTableP, $event)"
                    *ngIf="isBulkDelete"
                  ></p-tableCheckbox>
                </td>
                <td>
                    <span class="p-column-title">ID</span>
                    {{challenge.id}}
                </td>
                <td>
                    <span class="p-column-title">Name</span>
                    <a style="color: #81c784;" routerLink="/challenges/{{ challenge.id }}">{{challenge.name}} ({{challenge.id}})</a>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="8">No challenges Found </td>
            </tr>
        </ng-template>
    </p-table>
</div>

<p-confirmDialog
  header="Confirmation"
  icon="pi pi-exclamation-triangle"
></p-confirmDialog>
